export const PROFILES_MODULE_V1_URI = '/profile/v1/profiles/';
export enum PreferencesKey {
  recentlyViewed = 'recentlyViewed',
}
export enum SortOption {
  publishDate_asc = 'publishDate_asc',
  publishDate_desc = 'publishDate_desc',
  modifiedDate_asc = 'modifiedDate_asc',
  modifiedDate_desc = 'modifiedDate_desc',
  relevance = 'relevance',
  viewsLast24Hrs_desc = 'viewsLast24Hrs_desc',
  viewsLast7Days_desc = 'viewsLast7Days_desc',
  viewsLast30Days_desc = 'viewsLast30Days_desc',
}
